// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22A-x","colMin":"styles_colMin__2DAdB"};